<template>
  <div class="privacy__wrap">
    <Breadcrumb :config="breadcrumb" />
    <div class="m-useful-info layout">
      <div class="m-useful-info__container">
        <div class="m-useful-info__title heading-h2">有用的信息</div>
        <div class="clearfix">
          <div class="m-useful-info__menu-container menu-toggler" @click="clickMenu">
            <div>隐私条款</div>
            <span :class="showMenu?'selectboxit-arrow-up':'selectboxit-arrow-down'"></span>
          </div>
          <div class="c-toggler-content" v-if="showMenu">
            <ul class="c-refinement__values">
              <li
                :class="['c-refinement',selected==item.href?'selected':'']"
                v-for="item in menuList"
                :key="item.index"
                @click="clickSelect(item)"
              >
                <span>{{item.name}}</span>
                <span class="checkmark" v-if="selected==item.href">
                  <svg
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-useful-info__main-content">
          <article>
            <p>希思黎隐私保护服务条款</p>
            <p>Sisley法国希思黎中国官方网站尊重您的隐私权并重视您与我们的关系。您访问本网站时应遵守本隐私权政策及我们的使用条款，我们建议您对其进行查阅。</p>
            <p>本隐私权政策是关于希思黎（上海）化妆品商贸有限公司，以下简称希思黎公司，Sisley法国希思黎中国官方网站（位于www.sisley.com.cn简称“希思黎中国官网”）收集的个人信息，我们如何使用该信息，以及与何人分享该信息的介绍说明。我们的隐私权政策还介绍了我们采取什么措施来保护信息安全以及您如何查看、修改或删除您的个人信息。本政策也解释了您如何拒绝我们对您的个人信息的处理，以及如何拒绝接收我们的产品和服务通讯</p>
            <p>请注意本隐私政策只适用于通过上述“网站” 向希思黎中国官网在线提供的信息。本政策不适用于任何其他涉及希思黎的信息或通讯，比如，实物零售店中的希思黎专柜的通讯。如果您访问我其他地区的网站，或者本网站链接到的其他网站，您应遵守适用于该其他网站的隐私权政策，我们建议您对其进行查阅。</p>
            <p>请点击下面的链接转去相关段落：</p>
            <a class="small" href="#info">• 信息收集和使用</a>
            <a class="small" href="#spread">• 推广电邮</a>
            <a class="small" href="#message">• 短信</a>
            <a class="small" href="#communication">• 为您服务的通讯</a>
            <a class="small" href="#service">• 个性化服务</a>
            <a class="small" href="#question">• 问卷和调查和促销活动</a>
            <a class="small" href="#technology">• 使我们向您提供个性化网站服务的技术</a>
            <a class="small" href="#site">• 网站标记和跟踪链接</a>
            <a class="small" href="#cookes">• Cookies</a>
            <a class="small" href="#coremetrics">• Coremetrics公司</a>
            <a class="small" href="#share">• 我们分享的信息和分享者</a>
            <a class="small" href="#protect">• 我们如何保护个人信息</a>
            <a class="small" href="#privacy">• 隐私权政策更新</a>
            <a class="small" href="#update">• 更新您的资料</a>
            <a class="small" href="#td">• 退订和管理您的偏好</a>
            <a class="small" href="#company">• 希思黎公司</a>
            <a class="small" href="#third">• 第三方</a>
            <a class="small" href="#law">• 遵守法律</a>
            <a class="small" href="#transfer">• 将数据转移至其他国家</a>
            <!-- <a class="small" href="#data">•	数据控制者/数据处理者</a> -->
            <a class="small" href="#opinion">• 意见</a>
            <article id="info" class="article">
              <p>信息收集和使用</p>
              <p>您可以在访问我们的“网站”时向我们提供您的个人信息。比如，当填写在线调查表或用户登记表，或在希思黎中国官网购买产品时，您可能被要求提供某些信息，如您的联系资料（姓名、电邮地址、邮寄地址及电话号码）、年龄段、性别、护肤、化妆需要及您使用的品牌和产品。当您在希思黎中国官网发出订单时，我们还需要了解您的送货地址和付款地址，信用卡或借记卡号码、发卡公司和有效期。请注意，您在希思黎中国官网的注册信息，为了保护您的个人身份信息，在登记注册的用户必须输入用户名、电邮地址及密码。 如果您不希望我们收集任何您的个人信息，请不要向我们提供，可随时决定不再从希思黎公司接收或停止接收相关的电子邮件。您本人在此确认，您提供的数据，希思黎中国及希思黎法国总部（包括为他们提供服务的供应商），为了给您提供更好的服务，可进行使用及储存。希思黎中国官网的客服电话为400-821-1280。您可依据《中华人民共和国个人信息保护法》中的相关规定行使权力。</p>
            </article>
            <article id="spread" class="article">
              <p>推广电邮</p>
              <p>在您同意的情况下，我们可将您提供的信息用于制作及向您发送我们的业务通讯或调查，或其他包含产品信息、美容护肤等指导或促销的通讯（“电邮”）。如果您开始选择收到该类电邮而后来不希望再收到此类电邮，请查阅下面“更新您的资料”及“退订和管理您的偏好”，即使你不愿意收到此类电邮，您也可以通过邮寄或电话的方式收到希思黎中国官网的优惠或消息。如果你不希望接到直邮或电话，请查阅下面“更新您的资料”及“退订和管理您的偏好”段落。</p>
            </article>
            <article id="message" class="article">
              <p>短信</p>
              <p>根据您的选择，我们可以对您提供的手机号码生成并发送关于产品和活动信息、美容护肤等指导或促销的通讯（“短信”）。希思黎中国官网在线并不对这些短信收费，但您的手机服务商可能会向您收取短消息发送或接收费用及通讯费，以及手机服务商按其他标准收取的费用。如果您开始选择接收此类短信而后来决定不再接收，请查阅下面“更新您的资料”及“退订和管理您的偏好”段落。</p>
            </article>
            <article id="communication" class="article">
              <p>为您服务的通讯</p>
              <p>如果您选择向我们提供联系信息，我们将以包括电邮在内的任何方式向您发出有关“网站”的服务通告和密码取回通知，并就您的客户服务请求或您关于订单的问题与您联系。比如，所有注册用户都会收到一份欢迎电邮以便确认注册。此类通讯的目的是为更好的为您服务，解答您的疑问，提供希思黎中国官网对其客户进行的高水准服务。</p>
            </article>
            <article id="service" class="article">
              <p>个性化服务</p>
              <p>我们可能利用您的个人信息向您提供个性化网站服务和使用。比如，我们会向您建议您可能会特别感兴趣的产品。</p>
            </article>
            <article id="question" class="article">
              <p>问卷和调查和促销活动</p>
              <p>希思黎中国官网有时会赞助特别活动（如比赛、抽奖或其他活动）、问卷和调查。关于这些活动中您提供的个人信息的使用，您将看到促销活动的特别规则的解释。我们强烈建议您在参与促销活动前查阅有关规则。如果有关特别活动、问卷或调查不适用特别规则，个人信息的处理适用本隐私权政策和上述目的。这种调查会有助于我们提供更好的服务与产品，来满足消费者的需求。您参与完全是自愿性的，这些调查表可填，也可不填。</p>
            </article>
            <article id="technology" class="article">
              <p>使我们向您提供个性化网站服务的技术</p>
              <p>我们使用各种技术收集您访问我们网站的信息以便改善您的使用，并使您访问我们“网站”的体验个性化。 比如，我们会收集数字IP地址以便确认可能指明您所处的地理位置的电脑或设备。有些情况下，我们会将这些技术与您在“网站”上提供信息相结合。这些技术会提供各种信息，包括您是否以前曾访问我们的“网站”。这些技术也可使得您保存您的偏好。下面将详细介绍各种技术。</p>
            </article>
            <article id="site" class="article">
              <p>网站标记和跟踪链接</p>
              <p>网站标记（也称为净图象和像素标签），跟踪链接或类似技术由几行代码构成，内嵌于我们网站的网页中。他们经常与cookies合并使用，且“网站”的用户通常不会看到。网站标记可以向第三方（比如我们的服务提供者）传递信息，并可用于跟踪客户对某些广告的反应，以便更好的设计有针对性的互动广告，并改善客户支持和可用性。如果你拒绝我们的cookies（见以下“cookies”段落）, 您将阻止网站标记对您的信息传递，您可能不能使用“网站”的某些功能。</p>
            </article>
            <article id="cookes" class="article">
              <p>Cookies</p>
              <p>浏览器cookies是您访问我们的网站时在您的计算机硬盘上留下的少量文本。Flash cookies 与浏览器cookies相似，只是前者可以存储比简单文本更复杂的数据资料，并存贮在您的浏览器而非硬盘上。</p>
              <p>您可以拒绝我们的cookies。 如果您拒绝我们的cookies, 您还可以访问“网站”，但可能不能使用某些功能。临时cookies只用于您的购物方便，下订单后临时cookie就会过期。希思黎希望在您的计算机内安装cookie。Cookie无法让我们了解您的身份。它通常记录与您使用这台计算机浏览本网站有关的信息（您访问过的页面、访问的日期和时间等），以便我们能够在您之后访问时读取。我们向您告知，通过将网络浏览器设置为拒绝安装cookie或在安装这类文件前对您进行提醒，您可以避免cookie记录。</p>
            </article>
            <article id="coremetrics" class="article">
              <p>Coremetrics公司-只适用于希思黎官网</p>
              <p>我们一直致力于使您在浏览我们网站时拥有更好的体验。因此，我们聘请了Coremetrics公司帮助我们更好地了解您对希思黎中国官网的使用情况。我们将给您的电脑留下cookies以便收集您的信息，让我们了解您如何登陆和浏览希思黎中国官网。Coremetrics不会接收任何您的个人信息。Coremetrics有合同义务不以其他任何理由使用这些数据。Coremetrics有义务对代表我公司收集的数据进行保密。您可以拒绝让Coremetrics追踪您在希思黎中国官网上的表现。欲了解更多关于Coremetrics的个人和保密的各种等级，请前往Coremetrics官网。</p>
              <p>我公司的其他工作伙伴和服务商也可能在“网站”上应用cookies。然而，我公司并没有对这些cookies的掌握和控制权，我公司不对这些cookies负责。上段描述只用于Coremetrics cookies的接收或拒绝。</p>
            </article>
            <article id="share" class="article">
              <p>我们分享的信息和分享者</p>
              <p>第三方是我们指定的对您销售并送货的经销商的情况之外，未经您的同意，我们不会故意将您的个人信息提供给第三方供其向您推广他们的产品或服务。除本条规定之外，我们不出售或以其他方式泄漏“网站”访客的个人信息。</p>
            </article>
            <article id="protect">
              <p>如何保护个人信息</p>
              <p>我们对“网站”采取合理的安全措施以避免未经授权的披露、使用、修改或破坏您通过“网站”提供的个人信息。鉴于您通过公共因特网访问我们的“网站”，我们通过一个开放的网络即因特网收集您提供的个人信息，而该开放网络如果被骇客袭击，您的个人信息可能被未授权的第三方看到和使用。如果您对我们网站的安全有任何问题，可以发送电邮至cs@sisley.com.cn。</p>
              <p>您应充分理解与知晓，希思黎对于您处提供的信息会尽一切努力对其进行保密及维护，但对于任何希思黎无法控制的原因导致的信息问题及由此带来的损失和责任，希思黎免于承担由此而产生的相关责任及损失。</p>
            </article>
            <article id="privacy">
              <p>隐私权政策更新</p>
              <p>我们会不时修改本隐私权政策。如果我们决定更改我们的隐私权政策，我们将在此公布经修改的政策。我们建议您定期查看本隐私权政策。您可以在本页顶部找到本隐私政策的生效日。该隐私政策更新后即时生效。</p>
            </article>
            <article id="update">
              <p>更新您的资料</p>
              <p>您可以在“您的账户页面”进行阅读、更改或者要求删除您的个人信息，或者发送电子邮件至cs@sisley.com.cn进行咨询操作方式。</p>
            </article>
            <article id="td">
              <p>退订和管理您的偏好</p>
              <p>您可以选择是否接受我们发出的电邮 。您可点击您收到的我们每封电子邮件底部的“取消订阅”链接，或可以发送电子邮件至cs@sisley.com.cn随时更改您的选择。您可以发送电子邮件至cs@sisley.com.cn退订手机短信， 也可以发送电子邮件至cs@sisley.com.cn从而选择不收到我们的邮件或电话/手机通讯及注明您的偏好。</p>
            </article>
            <article id="company">
              <p>希思黎公司</p>
              <p>我们可与我们分销及营销希思黎产品的关联公司（“希思黎公司”）共享您的个人信息。希思黎公司可以遵照本隐私权政策使用该等信息，包括，在您同意后发送给您包括产品信息、美容护肤等指导和促销的电子邮件。如果您不希望我们与希思黎公司分享您的个人信息，请不要将您的信息提供给我们。在这种情况下，我们将不能向您提供希思黎中国官网的优惠。</p>
            </article>
            <article id="third">
              <p>第三方</p>
              <p>我们可聘请其他公司和个人遵照本隐私权政策代表我们履行职责。 比如数据分析公司、客户支持专业人员、电子邮件供应商、网络服务器公司及后勤服务公司（比如协调邮寄的公司等）。我们为了让这些第三方履行其职责，可能向其提供其所需的客户个人信息，但其使用这些资料时不可为任何其他目的使用这些资料，而且这些第三方应当遵守本隐私权政策。</p>
              <p>请注意，您在希思黎中国官网上订购的产品都将从我们指定的经销商处购买和发货。为其销售、送货和发送账单之便利，我们会将您的个人信息提供给经销商。经销商有合同义务禁止其在履行向您销售、送货、发送账单和对您提供相关服务的义务的必要范围之外使用客户的个人信息。此外，在一些情况下，我们可能征求您的意见是否将您的个人信息透露给第三方，如活动或促销的共同赞助者。如果您同意，我们将把您的个人信息透露给这些第三方供其为自己的目的使用，他们将遵守各自的隐私政策。</p>
            </article>
            <article id="law">
              <p>遵守法律</p>
              <p>为遵守有关法律、法规、法律程序或政府的要求，我们可披露所需信息。另外，若有必要，为避免人身伤害、经济损失或有关潜在或现时的非法活动，我们可以披露任何所需信息并免于承担由此而产生的任何法律责任。</p>
            </article>
            <article id="transfer">
              <p>将数据转移至其他国家</p>
              <p>根据本隐私权政策取得您的个人信息和包含您个人信息的数据库的关联方、希思黎公司或第三方可能位于中国、美国或其他国家，这些国家会对个人信息的法律保护程度不同。无论其位于何处，所有获得您的个人信息的关联方，希思黎公司或第三方都应遵守本隐私权政策所列的隐私保护声明。</p>
            </article>
            <article id="opinion">
              <p>意见</p>
              <p>希思黎隐私保护服务条款中的内容与顾客在“Sisley法国希思黎官方网站”中确认的内容存在不一致的，希思黎隐私保护服务条款中的内容优先适用。</p>
              <p>我们采取了大量措施，确保您对我们网站的访问顺利，并让您的隐私权始终得到尊重。如果您对我们的隐私权保护措施有任何质疑、意见或担心，您可以发送电子邮件至cs@sisley.com.cn如果您对短信有任何疑问，也可以发送电子邮件至cs@sisley.com.cn</p>
              <p>本文在全世界范围内的版权为希思黎（上海）化妆品商贸有限公司所有</p>
            </article>
          </article>
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div class="m-refinements__refinement-bar m-useful-info__menu-mobile" v-if="showMenu">
      <div class="m-refinements__filter-header m-useful-info-bar-open">
        <div class="m-refinements__close-btn clearfix">
          <button class="c-button c-button--rounded float-right close" @click="showMenu=false">
            <svg
              class="svg-inline cross"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="12px"
              height="12px"
              viewBox="0 0 612 612"
              style="enable-background:new 0 0 612 612;"
              xml:space="preserve"
            >
              <g>
                <g id="cross">
                  <g>
                    <polygon
                      points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
      <div class="m-refinements__list clearfix">
        <div class="c-refinement c-toggler c-toggler--expanded">
          <a
            href="#"
            class="c-refinement__header c-toggler__title"
            @click="hideMenu=!hideMenu"
          >有用的信息</a>
          <div :class="['c-refinement__body',hideMenu?'c-toggler__content':'']">
            <ul class="c-refinement__values">
              <li
                title="销售条款"
                class="c-refinement__value"
                v-for="item in menuList"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  :class="['c-refinement__value-link', selected==item.href?'selected':'']"
                >
                  <span class="c-refinement__value-link-name m-useful-info__menu-link">{{item.name}}</span>

                  <svg
                    v-if="selected==item.href"
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="m-refinements__apply-btn m-useful-info-bar-open">
        <button class="c-button c-button--secondary c-button--expand" @click="showMenu=false">应用</button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "Privacy",
  components: { Breadcrumb },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "隐私条款", href: "" }]
      },
      showMenu: false,
      hideMenu: false,
      menuList: [
        { name: "法律声明", href: "/legal" },
        { name: "条款与条件", href: "/terms" },
        { name: "隐私条款", href: "/privacy" },
      ],
      selected: "",
    };
  },
  mounted() {
    if (this.$route.path) {
      this.selected = this.$route.path;
    }
  },
  methods: {
    clickMenu() {
      this.showMenu = !this.showMenu;
    },
    clickSelect(item) {
      this.showMenu = !this.showMenu;
      this.$router.push({ path: item.href });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-useful-info { padding: 0 1.0625rem 3.75rem; }
.m-useful-info__container { padding: 3.125rem 0 0; }
.m-useful-info__title { text-align: center; font-size: 1.5265rem; margin-bottom: 1.875rem; }
.m-useful-info__menu-container { margin-bottom: 1.875rem; }
.menu-toggler {
  color: #000;
  line-height: 1.2;
  padding: 0.75rem 3.9375rem 0.75rem 2.0625rem;
  position: relative;
  cursor: pointer;
  border: 0.0625rem solid #cacaca;
  border-radius: 1.375rem;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
}
.c-toggler-content { display: none; }

.small { display: block; font-size: 10px; text-decoration: none; }
.article { padding-top: 70px; margin-top: -70px; }
.selectboxit-arrow-down, .selectboxit-arrow-up {
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  background-image: url("../assets/imgs/icons/arrow.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  right: 1.875rem;
}
.selectboxit-arrow-down { transform: rotateX(180deg); }
.selectboxit-arrow-up { transform: rotateX(0deg); }
.m-refinements__refinement-bar {
  position: fixed;
  right: 0;
  top: 0;
  transition: right 0.3s linear;
  background-color: #fff;
  height: 100%;
  width: 80%;
  z-index: 11;
}
.m-refinements__close-btn { padding: 1.5625rem 1.125rem 0.625rem 0; }
.c-toggler__title {
  position: relative;
  cursor: pointer;
  border-top: 0.0625rem solid #dfdfdf;
  border-bottom: 0.0625rem solid #dfdfdf;
  padding: 0.9375rem 0;
  margin-bottom: 0;
  display: block;
}
.c-refinement__header {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  border-top: none;
  padding: 1.5625rem 3.9375rem 1.5625rem 2.0625rem;
  text-decoration: none;
  display: block;
}
.c-refinement__body { background-color: #f5f5f5; padding: 0.9375rem 2.0625rem; }

.c-toggler__title:after {
  content: "";
  background: url("../assets/imgs/icons/arrow.svg") no-repeat;
  width: 0.9375rem;
  height: 0.5rem;
  right: 1.875rem;
  background-size: contain;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateY(-0.5px);
}

.c-refinement__value-link {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  text-decoration: none;
  display: block;
  padding: 0.625rem 0 0.625rem 1.875rem;
}
.c-refinement__value-link.selected { text-decoration: underline; padding-left: 0; }
.c-refinement__value-link.selected .checkmark { float: left; margin: 0.125rem 0.9375rem 0 0; }
.m-refinements__apply-btn { padding: 2.5rem 2.0625rem 7.8125rem; }
.m-refinements__apply-btn .c-button { font-size: 0.625rem; font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif; padding: 0.8125rem 1.875rem; }
.c-button--expand { display: block; width: 100%; margin-right: 0; margin-left: 0; max-width: 100%; }
.c-button--secondary, .order-tracking-popin .c-order__cancel-wrapper .c-button--primary-reversed {
  display: inline-block;
  vertical-align: middle;
  padding: 0.8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.625rem;
  line-height: 1;
  letter-spacing: 0.0625rem;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  border: 0.0625rem solid #cacaca;
  color: #000;
}
.c-toggler__content { display: none; }
@media screen and (max-width: 63.9375em) {
  .m-refinements__list {
    overflow-y: auto;
    height: -moz-calc(100vh - 276px);
    height: -webkit-calc(100vh - 276px);
    height: calc(100vh - 276px);
  }
}
@media screen and (min-width: 48em) {
  .m-useful-info { padding: 0 3.875rem 3.75rem; }
  .m-refinements__refinement-bar { display: none; }
  .c-refinement {
    min-width: 13.4375rem;
    font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
    font-size: 0.75rem;
    color: #000;
    text-decoration: none;
    display: block;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    cursor: pointer;
    border-radius: 0.5rem;
    &.selected { background-color: #f5f5f5; text-decoration: underline; }
  }
  .m-useful-info__title { text-align: left; float: left; }
  .m-useful-info__menu-container { float: right; }
  .c-toggler-content {
    display: block;
    position: absolute;
    z-index: 1;
    margin-top: 2.625rem;
    border-radius: 0.625rem;
    box-shadow: 0 0.3125rem 0.4375rem 0 hsla(0, 0%, 87.5%, 0.5);
    background-color: #fff;
    padding: 0.4375rem 0.5rem 0.5rem;
    right: 4rem;
  }
  .checkmark { float: right; }
}
@media screen and (min-width: 64em) {
  .breadcrumb { padding: 0 1.875rem; }
  .m-useful-info { padding: 0 1.875rem 3.75rem; }
  .m-useful-info__container { padding: 2.1875rem 6.25rem 0; }
  .m-useful-info__title { margin-bottom: 3.4375rem; }
  .m-useful-info__menu-container { margin-bottom: 3.4375rem; }
  .menu-toggler {
    border: 0.0625rem solid #cacaca; border-radius: 1.375rem; background-color: #fff;
    &:hover { background-color: #f5f5f5; }
  }
  .c-refinement {
    min-width: 14.6875rem;
    color: #575757;
    margin-top: 0.0625rem;
    border-radius: 0.5rem;
    min-width: 13.4375rem;
    white-space: nowrap;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    &.selected { background-color: #f5f5f5; text-decoration: none; padding-left: 0.6875rem; }
  }
  .c-toggler-content { right: 7rem; }
}
@media screen and (min-width: 75em) {
  .m-useful-info { padding: 0 0 5rem; }
  .m-useful-info__container { padding: 2.1875rem 12.5rem 0; }
}
</style>